module.exports = __webpack_public_path__ + "img/gb84.prt.74e7c78f.jpg";